import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AutomationPortalRuns } from '@/types/automations.ts';
import { AUTOMATION_PORTAL_RUNS_KEY } from '@/utils/queryKeys.ts';
import { get_automation_portal_runs_url } from '@/utils/urls.ts';

const useRetrieveAutomationPortalRuns = (
  automationId?: string,
  { limit = 10, enabled = true }: { limit?: number; enabled?: boolean } = {},
) => {
  const apiClient = useApiClient();

  return useQuery<AutomationPortalRuns, AxiosError>({
    queryKey: [...AUTOMATION_PORTAL_RUNS_KEY(automationId || ''), limit],
    queryFn: async () => {
      const response = await apiClient.get<AutomationPortalRuns>(
        get_automation_portal_runs_url(automationId),
        {
          params: { limit },
        },
      );
      return response.data;
    },
    enabled: !!automationId && enabled,
  });
};

export default useRetrieveAutomationPortalRuns;
